import { useState } from 'react';
import { Mail } from 'lucide-react';
import LetterModal from './LetterModal';
import './lettermodal.css';

const LetterButton = ({ contractor, project }) => {
    const [open, setOpen] = useState(false);

    const letters = contractor?.letter_section;
    const total = letters?.total_letter || 0;
    const pending = letters?.total_receive_letter_pending || 0;
    const closed = total - pending;

    return (
        <>
            <button className="letter-trigger-btn" onClick={() => setOpen(true)}>
                <div className="ltb-row">
                    <Mail size={11} className="ltb-mail-icon" />
                    <div className="ltb-stats-row">
                        <div className="ltb-stat-chip total">
                            <span className="ltb-chip-count">{total}</span>
                            <span className="ltb-chip-label">Total</span>
                        </div>
                        <div className="ltb-stat-chip pending">
                            <span className="ltb-chip-count">{pending}</span>
                            <span className="ltb-chip-label">Pending</span>
                        </div>
                        <div className="ltb-stat-chip closed">
                            <span className="ltb-chip-count">{closed}</span>
                            <span className="ltb-chip-label">Closed</span>
                        </div>
                    </div>
                </div>
                <span className="ltb-tooltip">View Letter Summary</span>
            </button>

            <LetterModal
                open={open}
                onClose={() => setOpen(false)}
                contractor={contractor}
                project={project}
            />
        </>
    );
};

export default LetterButton;